import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    body: String,
    button: String,
    style: { type: String, default: "default" },
    title: String,
    url: String,
  }

  async confirm(event) {
    event.preventDefault()
    event.stopPropagation()

    // Set data attributes on element for confirmMethod to read
    this.element.dataset.body = this.bodyValue
    this.element.dataset.button = this.buttonValue
    this.element.dataset.style = this.styleValue

    const confirmed = await window.confirmMethod(this.titleValue, this.element)

    if (confirmed) {
      const newWindow = window.open(this.urlValue, '_blank', 'noopener,noreferrer')
      if (newWindow) {
        newWindow.opener = null
      }
    }
  }
}
